export default __webpack_public_path__ + "static/media/Flaticon_1.93e92dbb.woff";